import React from 'react';
import { Link } from 'react-router-dom';
import './YouthTraining.css';

const YouthTraining = () => {
  return (
    <div className="youth-training-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Adolescent & Youth Training</h1>
          <p>Empowering the Next Generation to Lead, Adapt, and Thrive</p>
        </div>
      </section>

      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <h2>Empowering the Leaders of Tomorrow</h2>
            <div className="section-line"></div>
            <p className="lead">
              At The Blue Point, we nurture young minds to build confidence, character, and competence.
              Our specialized training programs are designed to equip adolescents and youth with essential
              life skills, soft skills, and leadership qualities to thrive in an ever-changing world.
            </p>
          </div>
        </div>
      </section>

      <section className="vision-mission-approach">
        <div className="container">
          <div className="vma-grid">
            <div className="vma-card">
              <h3>Our Vision</h3>
              <p>
                To create a world where every young individual is equipped to face challenges, lead with
                empathy, and contribute positively to society.
              </p>
            </div>

            <div className="vma-card">
              <h3>Our Mission</h3>
              <p>
                To empower adolescents and youth to unlock their potential by equipping them with the skills
                and mindset needed to excel in all areas of life.
              </p>
            </div>

            <div className="vma-card">
              <h3>Our Approach</h3>
              <ul>
                <li>Interactive Learning: Engaging sessions that encourage active participation</li>
                <li>Holistic Growth: Focused on intellectual, emotional, and social development</li>
                <li>Real-World Application: Practical activities and scenarios</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="programs-section">
        <div className="container">
          <h2 className="section-title">Our Programs</h2>
          <div className="section-line"></div>

          <div className="programs-grid">
            <div className="program-card">
              <div className="program-number">01</div>
              <h3>Life Skills Training</h3>
              <p>
                Master essential skills for everyday life, including problem-solving, decision-making,
                interpersonal relationships and effective communication.
              </p>
              <div className="program-modules">
                <h4>Key Modules:</h4>
                <ul>
                  <li>Self Awareness Building</li>
                  <li>Empathy & Critical Thinking</li>
                  <li>Communication & Decision Making</li>
                  <li>Problem Solving & Coping with Stress</li>
                  <li>Emotional Intelligence & Time Management</li>
                </ul>
              </div>
            </div>

            <div className="program-card">
              <div className="program-number">02</div>
              <h3>Soft Skills Development</h3>
              <p>
                Stand out with skills that set you apart in personal and professional settings. Build a
                strong foundation in communication, teamwork, and interpersonal relationships.
              </p>
              <div className="program-modules">
                <h4>Key Modules:</h4>
                <ul>
                  <li>Public Speaking</li>
                  <li>Active Listening</li>
                  <li>Negotiation and Persuasion</li>
                </ul>
              </div>
            </div>

            <div className="program-card">
              <div className="program-number">03</div>
              <h3>Personality Development</h3>
              <p>
                Unlock your true potential by developing confidence, self-awareness, and a positive attitude.
                Present the best version of yourself.
              </p>
              <div className="program-modules">
                <h4>Key Modules:</h4>
                <ul>
                  <li>Self-Confidence Building</li>
                  <li>Personal Branding</li>
                  <li>Body Language and Etiquette</li>
                </ul>
              </div>
            </div>

            <div className="program-card">
              <div className="program-number">04</div>
              <h3>Leadership Development</h3>
              <p>
                Shape yourself into an inspiring and influential leader. Learn how to motivate teams,
                solve complex challenges, and lead with integrity.
              </p>
              <div className="program-modules">
                <h4>Key Modules:</h4>
                <ul>
                  <li>Visionary Thinking</li>
                  <li>Team Management</li>
                  <li>Decision-Making Skills</li>
                </ul>
              </div>
            </div>

            <div className="program-card">
              <div className="program-number">05</div>
              <h3>Adaptability & Resilience Training</h3>
              <p>
                Prepare for the dynamic world by learning how to embrace change and thrive in uncertain
                environments. Cultivate a growth mindset and overcome setbacks with grace.
              </p>
              <div className="program-modules">
                <h4>Key Modules:</h4>
                <ul>
                  <li>Coping with Change</li>
                  <li>Stress Management</li>
                  <li>Building Resilience</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="special-programs">
        <div className="container">
          <h2 className="section-title">Special Programs</h2>
          <div className="section-line"></div>

          <div className="special-grid">
            <div className="special-card">
              <div className="special-image">
                <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600" alt="Kool Kite Programme" />
              </div>
              <div className="special-content">
                <h3>Kool Kite Programme</h3>
                <p>
                  An exclusive programme for adolescents designed by the Blue Point Org, based on well-tested
                  modules and methodology of life skills education and Leadership Development. The modules can
                  be customized to suit the requirements of different age groups and institutions.
                </p>
                <p>
                  The Kool Kite programmes are being rolled out with the support of Individual Institutions,
                  Government Agencies/Departments and Corporates.
                </p>
              </div>
            </div>

            <div className="special-card">
              <div className="special-image">
                <img src="https://images.unsplash.com/photo-1531482615713-2afd69097998?w=600" alt="Personal Growth Lab" />
              </div>
              <div className="special-content">
                <h3>Personal Growth Lab</h3>
                <p>
                  Advanced module on life skills, values, leadership and teamwork, designed for young adults.
                  The focus is on building Reflective Skills, Social Skills and Communication Skills of the participants.
                </p>
                <p>
                  The five-day programme helps participants understand and experience core life skills in detail,
                  preparing them for professional and personal success.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="section-line"></div>

          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">👨‍🏫</div>
              <h3>Experienced Trainers</h3>
              <p>Learn from seasoned professionals with years of expertise and a passion for youth development</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>Tailored Programs</h3>
              <p>Customized training to suit the unique needs of individuals and groups</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">🤝</div>
              <h3>Supportive Environment</h3>
              <p>A safe and inclusive space for growth and learning</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">📈</div>
              <h3>Proven Results</h3>
              <p>Hundreds of young individuals have successfully transformed their lives through our programs</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Unlock Your Potential?</h2>
            <p>
              Join our dynamic training programs and take the first step towards a brighter future.
            </p>
            <Link to="/contact" className="btn btn-large">Enroll Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YouthTraining;
